@if (!isSmallBubble) {
  <div class="big-bubble" [ngClass]="color">
    <svg
      width="74"
      height="76"
      viewBox="0 0 74 76"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M36 76C64 76 74 60.1312 74 38.095C74 16.0589 68 2.18506 42 0.190065C16 -1.80493 0 12.0689 0 34.105C0 56.1412 8 76 36 76Z"
        fill="#CCD6FF"
        />
      </svg>
      @if (!svgIcon) {
        <h1 class="abbrev">{{ abbreviation }}</h1>
      }
      @if (svgIcon) {
        <mat-icon class="icon" [svgIcon]="svgIcon"></mat-icon>
      }
    </div>
  }

  @if (isSmallBubble) {
    <div class="small-bubble" [ngClass]="color">
      <svg
        width="37px"
        height="38px"
        viewBox="0 0 37 38"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        >
        <path
          class="path"
          d="M18,38 C32,38 37,30.0655875 37,19.0475162 C37,8.02944487 34,1.09253156 21,0.0950324098 C8,-0.902466737 0,6.03444657 0,17.0525179 C0,28.0705892 4,38 18,38 Z"
          fill="#CCD6FF"
        ></path>
      </svg>
      @if (!svgIcon) {
        <span class="abbrev bold">{{ abbreviation }}</span>
      }
      @if (svgIcon) {
        <mat-icon [svgIcon]="svgIcon"></mat-icon>
      }
    </div>
  }
